import { useCallback } from 'react';

// Prevent the native <input type="number"> spinner from firing on wheel and
// silently bumping the value. Blurring alone is not enough because the browser
// already processed the increment before blur runs, so we also mark the
// event as "handled" via preventDefault (works on non-passive React 16
// synthetic wheel listeners — inputs inside forms are not passive).
// Callers that render `<input type="number">` should attach this handler.
const handleWheel = (event) => {
  if (typeof event.preventDefault === 'function') {
    event.preventDefault();
  }
  if (event.target && typeof event.target.blur === 'function') {
    event.target.blur();
  }
};

export const usePreventWheelChange = () => useCallback(handleWheel, []);

// Standalone function for non-hook contexts
export const preventWheelChange = handleWheel;
